export const downloadBlob = (blob: Blob, fileName: string): void => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    // eslint-disable-next-line
    a.href = url;
    a.download = fileName;
    a.click();
};
